<template>
	<core-modal
		name="show-lead-modal"
		class="show-lead-modal"
		headerText="Lead Details"
		v-on="$listeners"
	>
		<modals-content v-if="lead">
			<core-form-text-input label="Name" :input="leadName" :disabled="true"></core-form-text-input>
			<core-form-text-input label="Email" :input="lead.email" :disabled="true"></core-form-text-input>
			<core-form-text-input label="Phone" :input="lead.phone" :disabled="true"></core-form-text-input>
			<core-form-text-input label="Campaign" :input="lead.campaign_name" :disabled="true"></core-form-text-input>
			<core-form-text-input label="Site" :input="site" :disabled="true"></core-form-text-input>
			<core-form-text-input label="Tags" :input="tags" :disabled="true"></core-form-text-input>
			<core-form-text-input label="Date Received" :input="dateReceived" :disabled="true"></core-form-text-input>
			<core-form-text-input label="Referring Page Title" :input="lead.page_title" :disabled="true"></core-form-text-input>
			<core-form-text-input label="Referring Page URL" :input="lead.page_url" :disabled="true"></core-form-text-input>
			<core-form-text-input label="IP Address" :input="lead.ip" :disabled="true"></core-form-text-input>
		</modals-content>
	</core-modal>
</template>

<script>
export default {
	props    : [ 'lead' ],
	computed : {
		leadName () {
			return this.lead.last_name ? `${this.lead.first_name} ${this.lead.last_name}` : this.lead.first_name
		},
		site () {
			return `${this.lead.site_name} (${this.lead.site_domain})`
		},
		tags () {
			return this.lead.tags.join(', ')
		},
		dateReceived () {
			return this.$moment(this.lead.created).format('MM/DD/YYYY HH:mm')
		},
	},
}
</script>

<style lang="scss" scoped>

</style>
